import React, { useState } from 'react';
import { Button } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useUserBonusCoefficients, useCompanies, useUsers } from '../../../hooks';
import UserBonusCoefficientsBulkModal from './UserBonusCoefficientsBulkModal';

// Mevcut tek-tek "Katsayı Ekle" formu yerine üst-sağda (CSV İndir butonunun
// yanında) bulk modal'ı açan buton var. Düzenleme/silme satır bazlı eski
// şekilde DynamicCrudPage'in default akışıyla çalışır.
const buildFormFields = (fields, additionalData, isRootUser) => {
  const userList = additionalData?.users?.users || [];
  const companyList = additionalData?.companies?.companies || [];

  return fields
    .map((f) => {
      if (f.name === 'companyId') {
        return {
          ...f,
          options: companyList.map((c) => ({ value: c.id, label: c.name })),
          showIf: () => isRootUser,
        };
      }
      if (f.name === 'user_id') {
        const seen = new Set();
        return {
          ...f,
          options: userList
            .filter((u) => (seen.has(u.id) ? false : seen.add(u.id)))
            .map((u) => ({
              value: u.id,
              label: `${(`${u.firstName || ''} ${u.lastName || ''}`).trim() || 'Kullanıcı'} #${u.id}`,
            })),
        };
      }
      return f;
    })
    .filter((f) => (f.name === 'companyId' ? isRootUser : true));
};

const UserBonusCoefficientsPage = () => {
  const { t } = useTranslation();
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  // DynamicCrudPage'in iç hook'unu remount ederek liste refresh ediyoruz.
  const [refreshKey, setRefreshKey] = useState(0);

  // CSV İndir butonunun solunda görünen toolbar butonu.
  const headerBulkButton = (
    <Button
      variant="contained"
      size="small"
      startIcon={<EditNoteIcon />}
      onClick={() => setBulkModalOpen(true)}
      sx={{ mr: 1, textTransform: 'none', boxShadow: 'none' }}
    >
      {t('userBonusCoefficients.bulk.editButton')}
    </Button>
  );

  return (
    <>
      <DynamicCrudPage
        key={refreshKey}
        entityType="userBonusCoefficients"
        hook={useUserBonusCoefficients}
        additionalHooks={{ companies: useCompanies, users: useUsers }}
        entityTypeForDataTable="userBonusCoefficients"
        customFormFields={buildFormFields}
        showAddButton={false}
        headerExtraContent={headerBulkButton}
      />
      <UserBonusCoefficientsBulkModal
        open={bulkModalOpen}
        onClose={() => setBulkModalOpen(false)}
        onSaved={() => setRefreshKey((k) => k + 1)}
      />
    </>
  );
};

export default UserBonusCoefficientsPage;
